module.exports = __webpack_public_path__ + "img/stock2.0cb71f07.png";